const comercializacao = {
  SERVICO: 'Serviço',
  PRODUTO: 'Produto',
  AMBOS: 'Ambos',
};

export const getValue = (value) => {
  if (value === 'SERVICO') {
    return comercializacao.SERVICO;
  } else if (value === 'PRODUTO') {
    return comercializacao.PRODUTO;
  } else if (value === 'AMBOS') {
    return comercializacao.AMBOS;
  } else {
    return '';
  }
}

export default comercializacao;
